export const SHOPGOODWILL_CHANNEL_ID = 1
// const EBAY_CHANNEL_ID = 2 // LATER

export type ListingType = 'AUCTION' | 'FIXED_PRICE'

export type SgwForm = {
  listingType?: ListingType
  price?: string // Don't think about auction vs fixed price. Just think of this as "price".
  buyItNowPrice?: string
  shippingPrice?: string
  carrierId?: number
  bidIncrement?: string
  reservePrice?: string
  handlingPrice?: string
  categoryMarketCategoryId?: number
  auctionDuration?: string
}
